<script setup lang="ts" generic="T">
interface IProps {
  modelValue?: boolean
  name?: string
  error?: string
  disabled?: boolean
}

defineProps<IProps>()
const emit = defineEmits(['update:modelValue', 'change'])

const handleChange = (e: Event) => {
  const target = e.target as HTMLInputElement
  emit('change', e)
  if (!e.defaultPrevented)
    emit('update:modelValue', target.checked)
}
</script>

<template>
  <label class="relative flex items-center gap-2 cursor-pointer">
    <input
      :checked="modelValue"
      :name="name"
      :disabled="disabled"
      type="checkbox"
      class="custom-checkbox"
      relative t-1 l-1 appearance-none
      before:color-white before:rounded-full before:flex before:items-center before:justify-center before:h-5 before:w-5 before:b-1 before:bg-white before:b-bluishSofter
      checked:before:b-black-softer checked:before:bg-black-softer
      @change="handleChange"
    >
    <slot />
  </label>
</template>

<style scoped>
.custom-checkbox::before {
  content: ''
}
.custom-checkbox:checked::before {
  content: url('data:image/svg+xml,%3Csvg%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%3Cg%20clip-path%3D%22url%28%23clip0_5290_5080%29%22%3E%20%3Cpath%20d%3D%22M0%206.59999L1.2%205.39999L4.2%208.39999L10.8%201.79999L12%202.99999L4.2%2010.8L0%206.59999Z%22%20fill%3D%22white%22%2F%3E%20%3C%2Fg%3E%20%3Cdefs%3E%20%3CclipPath%20id%3D%22clip0_5290_5080%22%3E%20%3Crect%20width%3D%2212%22%20height%3D%2212%22%20fill%3D%22white%22%2F%3E%20%3C%2FclipPath%3E%20%3C%2Fdefs%3E%20%3C%2Fsvg%3E');
}
</style>
